import React, {useState} from 'react';
import './news.css';
import NewElement from "./NewElement/NewElement";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import {MonthToText} from "../../../../AdminPart/src/Constants";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

function CompanyNewsSourceGatsby (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}
    let ThisYear = new Date();
    const [NewsPage, setNewsPage] = useState(1);
    const [NewsYear, setNewsYear] = useState(ThisYear.getFullYear());

// Нам нужно чтобы ChangeNews выдавало список новостей. запрашивала правильные части чтобы при клике на номере новостей - выдавались именно нужные новости. От и До. Есть выбор номера года и выбор номера.
    //console.log('CompanyNewsSourceGatsby',props.ArrayOfAllNews);
    function SetNewsYearAndPage(NewsYear,NewsPage) {
        setNewsPage(NewsPage);
        setNewsYear(NewsYear);
    }

    function TakeNewsWeNeed(NewsYear,NewsPage, QuantityOnPage) {
        let lang = props.lang;
        const AllNews = props.ArrayOfAllNews.map(function(Novamen) {
            if (+Novamen.NewsDate.split('-')[0] === NewsYear) {
                return <div key={Novamen._id}>
                    <NewElement
                        NewDate={Novamen.NewsDate.split('-')[2] + ' ' + MonthToText(Novamen.NewsDate.split('-')[1], lang) + ' ' + Novamen.NewsDate.split('-')[0]}
                        NewTitle={JSON.parse(Novamen.Title)[lang]}
                        NewText={JSON.parse(Novamen.Text)[lang]}
                        DopInfo={Novamen.DopInfo}
                    />
                </div>
            }
            else return 1
        });
        const AllNewsFilter = AllNews.filter(function (News) {
            return News !== 1
        });
        // console.log('AllNewsFilter',AllNewsFilter);
        const NewsWeNeed = [];
        for (let i=0; i<QuantityOnPage; i++) {
            NewsWeNeed[i] = AllNewsFilter[(NewsPage-1)*QuantityOnPage+i]
        }
        // console.log('NewsWeNeed',NewsWeNeed);
        return (
            <React.Fragment>{NewsWeNeed}</React.Fragment>
        )}

    function TakeNewsPagesOfThisYear(NewsYear, QuantityOnPage) { // Все, что функция делает, это высчитывает количество новостей в этом годе
        const NovamensOfThisYear = (props.ArrayOfAllNews.map(function(Novamen) {if (+Novamen.NewsDate.split('-')[0] === NewsYear) {return Novamen} else {return ''}} )).filter((number) => number); // Мы просто получаем все новости за этот год
        const NewsPages = [];
        let AddPage = 0; // Если надо добавить страницу
        if (NovamensOfThisYear.length % QuantityOnPage !== 0) {AddPage=1} // Добавляем страницу если у нас не делится точно на страницы количество новостей
        for (let i=1; i<Math.floor(NovamensOfThisYear.length/QuantityOnPage)+AddPage+1; i++) {
            NewsPages[i] = <div key={i} className={NewsPage === i ? "CompanyNewsPagesElement CompanyNewsPagesElementActive" : 'CompanyNewsPagesElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(NewsYear,i)}><div className={"CompanyNewsPagesElementStick " }/>{i}</div>;}
        return NewsPages;
    }

        return (
            <>
                    <div className="StandartNOTitle"/>
                    <div className="StandartWhitePart">
                        <div className="CompanyNewsTitlePart">
                            <div className="StandartWhitePartTitle"><TextSource ArrIndex= 'News0015'>Новости</TextSource> </div>
                            <div className="StandartWhitePartYears">
                                <div className={NewsYear === 2021 ? "StandartWhitePartYearElement StandartWhitePartYearElementActive" : 'StandartWhitePartYearElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(2021,1)}><div className="StandartWhitePartYearElementStick"/>2021</div>
                                <div className={NewsYear === 2020 ? "StandartWhitePartYearElement StandartWhitePartYearElementActive" : 'StandartWhitePartYearElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(2020,1)}><div className="StandartWhitePartYearElementStick"/>2020</div>
                                <div className={NewsYear === 2019 ? "StandartWhitePartYearElement StandartWhitePartYearElementActive" : 'StandartWhitePartYearElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(2019,1)}><div className="StandartWhitePartYearElementStick"/>2019</div>
                                <div className={NewsYear === 2018 ? "StandartWhitePartYearElement StandartWhitePartYearElementActive" : 'StandartWhitePartYearElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(2018,1)}><div className="StandartWhitePartYearElementStick"/>2018</div>
                                <div className={NewsYear === 2017 ? "StandartWhitePartYearElement StandartWhitePartYearElementActive" : 'StandartWhitePartYearElement'} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => SetNewsYearAndPage(2017,1)}><div className="StandartWhitePartYearElementStick"/>2017</div>
                            </div>
                        </div>
                        <div className="CompanyNewsGrid">
                            {TakeNewsWeNeed(NewsYear,NewsPage,5)}
                        </div>
                        <div className="CompanyNewsPages">
                            {TakeNewsPagesOfThisYear(NewsYear,5)}
                        </div>
                    </div>
            </>

        )}
export default CompanyNewsSourceGatsby